export default async (context, { info, status }) => {
    let arr = {}
    let is_validate = false

    if(context.$route.query.code) {

        arr.code = context.$route.query.code
        arr.order = Number(context.$route.query.order)
        is_validate = true

    } else if(context.token) {

        arr.tocken = context.token
        arr.order = info.order
        is_validate = true

    } else {
        context.$router.push('/auth-check-order')
    }

    arr.state = status

    if(is_validate) {
        context.loading = true

        await context.$axios.post('/setOrderState', arr)
            .then(async ({ data }) => {
                if(data.success) {
                    context.error.status = false
                    context.error.text = ''
                    context.loading = false
                    await context.check_order(context)
                } else {
                    context.error.text = 'Упс! Что-то пошло не так. Повторите попытку позже.'
                    context.overlay = true
                    context.error.status = true
                    context.loading = false
                }
            })
            .catch(e => {
                console.error(e)
                context.error.text = 'Ошибка сервера! Не удалось поменять статус заказа. Повторите попытку позже.'
                context.overlay = true
                context.error.status = true
                context.loading = false
            })
    }
}